import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box, Typography, Avatar, Chip, CircularProgress } from '@mui/material';
import { API_KEY,  } from 'src/utils/pnd/PndConstants';
import mapStyle from '../../../RiderLiveMap/mapStyle';

// getMarkerIcon removed to use Pin.png image

const RiderLocationMap = ({ data }) => {
  const [isOpened, setIsOpened] = useState(true);
  const { isLoaded } = useJsApiLoader({ id: 'google-map-script', googleMapsApiKey: API_KEY });
  const containerStyle = { width: '100%', height: '100%' };
  const position = {
    lat: parseFloat(data?.latitude) || 25.276987,
    lng: parseFloat(data?.longitude) || 55.296249,
  };

  if (!isLoaded) return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress sx={{ color: '#32CA73' }} />
    </Box>
  );

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={position}
      zoom={15}
      options={{ styles: mapStyle, disableDefaultUI: false, zoomControl: true }}
    >
      <Marker
        position={position}
        onClick={() => setIsOpened(!isOpened)}
        icon={{
          url: '/img/pnd/Pin.png',
          scaledSize: new window.google.maps.Size(46, 46),
          anchor: new window.google.maps.Point(23, 46)
        }}
      >
        {isOpened && (
          <InfoWindow 
            position={position} 
            options={{ pixelOffset: new window.google.maps.Size(0, -45) }}
            onCloseClick={() => setIsOpened(false)}
          >
            <Box sx={{ p: 1.5, minWidth: 260 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                <Avatar sx={{ bgcolor: '#32CA73', mr: 1, width: 28, height: 28, fontSize: '0.8rem' }}>
                  {data?.riderName ? data.riderName[0].toUpperCase() : 'R'}
                </Avatar>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                  {data?.riderName}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 1 }}>
                <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, mr: 1 }}>
                  Plate Number:
                </Typography>
                <Typography variant="body2" sx={{ color: '#334155', fontWeight: 500 }}>
                  {data?.plateNo || 'N/A'}
                </Typography>
              </Box>

              {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 1 }}>
                <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, mr: 1 }}>
                  Current Status:
                </Typography>
                <Chip
                  label={data?.riderStatus || 'Unknown'}
                  size="small"
                  sx={{ height: 20, fontSize: '0.65rem', fontWeight: 700 }}
                />
              </Box> */}

              {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', mb: 1 }}>
                <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, mr: 1 }}>
                  Assigned Hub:
                </Typography>
                <Typography variant="body2" sx={{ color: '#334155', fontWeight: 500 }}>
                  {data?.storeName || 'N/A'}
                </Typography>
              </Box> */}
               <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, mr: 1, whiteSpace: 'nowrap' }}>
                 Location:
                </Typography>
                <Typography variant="body2" sx={{ color: '#334155', fontWeight: 500, textAlign: 'left' }}>
                  {data?.location || 'Unknown'}
                </Typography>
              </Box>
            </Box>
          </InfoWindow>
        )}
      </Marker>
    </GoogleMap>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(RiderLocationMap);
